<template>
    <div id="container">
        <div id="studyObjectiveContainer">
            <header class="mdc-top-app-bar">
                <div class="mdc-top-app-bar__row study-intro-topbar">
                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                        <a class="material-icons mdc-top-app-bar__navigation-icon t-color-white" @click="moveLearnView()">close</a>
                    </section>
                    
                    <section class="mdc-top-app-bar__section title">
                        <div class="mdc-top-app-bar__title study-intro-topbar__title">
                            {{$t('1046')}}
                            <!-- Learning Objectives -->
                        </div>                
                    </section>

                    <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                        <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                    </section>
                </div>
                
            </header>
            
            <span class="lesson-title typography--h10 text-center">
                {{name}}
            </span>
            <div v-if="teacherName">
                <span class="typography--b4">
                    {{$t('1047')}}
                    <!-- by -->
                </span>
                <span class="typography--b5">
                    {{teacherName}}
                </span>
            </div>
            <section class="objectives">
                <div>
                    <div class="t-body5">
                        {{learnPurposes}}
                    </div>
                </div>
            </section>
            <button class="btn-submit" @click="startStudy">
                {{$t('1048')}}
                <!-- Start -->
            </button>
        </div>
    </div>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 인트로 컴포넌트(my learning lesson study - intro component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'

import { captureApiError } from "@/utils/sentryApiHandler.js";

export default {
    
    data() {
        return {
            name: '',
            teacherName : '',
            learnPurposes: '',
            objectiveData: null
        }
    },

    watch: {
        '$route' (to, from) {
            this.fatchData()
        }
    },

    created() {
        this.fatchData()
    },

    methods: {
        fatchData() {
            let params = this.setParams()

            // 학습목표 API 호출(get Learning Objectives)
            learnApi.learnLessonObjective(params).then((response) => {
                let responseData = response.data.data
                this.objectiveData = responseData
                this.name = this.objectiveData.name
                this.teacherName = this.objectiveData.teacher ? this.objectiveData.teacher.fullName : ''
                this.learnPurposes = this.getLearnPurposes(this.objectiveData.learnPurposes)
            }).catch((err) => {
                console.log('learnLessonObjective error > ', err);
                captureApiError({
                    err,
                    frontRoute: this.$route,
                    frontData: this.$data,
                });
            })
        },

        // 학습 시작(start learing)
        startStudy() {
            let goBackBookMarkLessson = localStorage.getItem('bookMarkLesson')
            let goBackLikeLessson = localStorage.getItem('likeLesson')
            if(goBackBookMarkLessson == 'setGoBackBookMarkLesson'){
                localStorage.removeItem('bookMarkLesson');
                localStorage.setItem('videoBookMarkLesson','setVideoBookMarkLesson')
            }else if(goBackLikeLessson == 'setlikeLesson'){
                localStorage.removeItem('likeLesson');
                localStorage.setItem('videoLikeLesson','setVideoLikeLesson')
            }
            this.$emit('startStudy')
        },

        // 나의 학습 상세로 이동(Move to my Learning view)
        moveLearnView() {
            let goBackBookMarkLessson = localStorage.getItem('bookMarkLesson')
            let goBackLikeLessson = localStorage.getItem('likeLesson')
            //let goBackBookMarkLessson = localStorage.getItem('bookMarkLesson')
            if(goBackBookMarkLessson == 'setGoBackBookMarkLesson'){
                localStorage.removeItem('bookMarkLesson');
                this.$router.push({
                    name: 'BookMarkedLesson' 
                })
            }else if(goBackLikeLessson == 'setlikeLesson'){
                localStorage.removeItem('likeLesson');
                this.$router.push({
                    name: 'LikedLesson' 
                })
            } else{
                this.$router.push({
                    name: 'LearnView', 
                    params: {learnId: this.$route.params.learnId},
                    query: this.$route.query
                })
            }
            
        },

        // API 호출 파라미터 설정(set parameter)
        setParams() {
            let params = {
                 learnId: this.$route.params.learnId,
                progressionId: this.$route.params.progressionId
            }

            return params
        },

        // get learning Purpose
        getLearnPurposes(obj) {
        /**
             * language 설정 정보 가져오기
             * languageInfo가 undefined, null인 케이스가 있을 수 있음
             * .code가 없을 경우 en으로 설정
         */
            let setedLanguage = JSON.parse(localStorage.getItem('languageInfo')) && JSON.parse(localStorage.getItem('languageInfo')).code ? JSON.parse(localStorage.getItem('languageInfo')).code : 'en';
            let learnPurposes = '';
            if (obj) {
                if (obj[setedLanguage]) {
                    learnPurposes = obj[setedLanguage]
                }else {
                    if (obj['en']) {
                        learnPurposes = obj['en']
                    }else {
                        learnPurposes = obj[Object.keys(obj)[0]]
                    }
                }
            }
            return learnPurposes
        }
    },
}
</script>
